import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPythonComponent } from './simple-icons-python.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPythonComponent ],
    exports:      [ SimpleIconsPythonComponent ],
    bootstrap:    []
})
export class SimpleIconsPythonModule {}
